<div class="alert alert-success" role="alert"
  *ngIf="biometryLog?.valid || (biometryLog?.userSupervisorApprove && biometryLog?.userSupervisorApprove != undefined && biometryLog?.userSupervisorApprove != '')">
  <h4 class="alert-heading"><i class="fa fa-check-circle mr-2" aria-hidden="true"></i>Validación biométrica </h4>
  <p>Validación biométrica completada correctamente. <b>Por favor, continúe con el siguiente paso.</b></p>
  <hr>
</div>
<app-biometry [customer]="customer" [isForCreditRequest]="isForCreditRequest"
  [showActionButtonWithApprove]="showActionWithApprove" [showActionButtonWithoutApprove]="showActionWithoutApprove"
  [textActionButtonWithApprove]="'Crear solicitud con aprobacion de jefe de tienda'"
  [textActionButtonWithoutApprove]="'Crear solicitud'" [creditRequestNumber]="creditRequestNumber"
  [pictureUrl]="pictureUrlString" [biometryCompleted]="isBiometryCompleted"
  (biometryResultEmitter)="handleBiometryResult($event)" (biometryErrorEmitter)="handleBiometryError($event)"
  (clickActionButtonWithApprove)="handleClickButtonActionWithApprove()"
  (clickActionButtonWithoutApprove)="handleClickButtonActionWithoutApprove()" (cleanEmitter)="handleClean()"
  (pictureTakenEmitter)="handlePictureTaken($event)" [showTokenButton]="false" [showDefaultText]="true">
</app-biometry>